import React from 'react';
import '../styles/WhyChooseUs.css';

const WhyChooseUs = () => {
  const trustFactors = [
    {
      id: 1,
      icon: '🏆',
      title: '20+ Years Experience',
      description: 'Decades of proven pest control expertise and customer satisfaction.'
    },
    {
      id: 2,
      icon: '👨‍🔧',
      title: 'Certified Technicians',
      description: 'Highly trained, licensed, and background-checked professionals.'
    },
    {
      id: 3,
      icon: '🌿',
      title: 'Eco-Friendly Solutions',
      description: 'Safe for your family, pets, and the environment.'
    },
    {
      id: 4,
      icon: '⭐',
      title: 'Satisfaction Guaranteed',
      description: 'We stand behind our work with a 100% satisfaction guarantee.'
    },
    {
      id: 5,
      icon: '⏱️',
      title: 'Same-Day Service',
      description: 'Quick response times when you need us most.'
    },
    {
      id: 6,
      icon: '💰',
      title: 'Best Price Guarantee',
      description: 'Competitive pricing with no hidden fees or surprises.'
    }
  ];

  const steps = [
    {
      id: 1,
      icon: '📅',
      title: 'Book Online',
      description: 'Schedule your service in minutes using our easy online booking system.'
    },
    {
      id: 2,
      icon: '🔍',
      title: 'Get Inspection',
      description: 'Our experts inspect your property and identify the pest problem.'
    },
    {
      id: 3,
      icon: '🏠',
      title: 'Enjoy Pest-Free Living',
      description: 'We eliminate pests and provide prevention tips for lasting results.'
    }
  ];

  const handleGetStarted = () => {
    window.location.href = 'tel:+18334936242';
  };

  return (
    <section className="wcu-section" id="why-choose-us">
      <div className="wcu-container">
        {/* Section Header */}
        <div className="wcu-header">
          <span className="wcu-tag">Why Choose Us</span>
          <h2 className="wcu-title">Your Trusted Pest Control Partner</h2>
          <p className="wcu-subtitle">
            We're committed to providing exceptional service with transparency, integrity, 
            and results you can count on.
          </p>
        </div>

        {/* Trust Factors Grid */}
        <div className="wcu-trust-grid">
          {trustFactors.map((factor) => (
            <div className="wcu-trust-card" key={factor.id}>
              <div className="wcu-trust-icon">{factor.icon}</div>
              <h3 className="wcu-trust-title">{factor.title}</h3>
              <p className="wcu-trust-description">{factor.description}</p>
            </div>
          ))}
        </div>

        {/* Divider with Process Label */}
        <div className="wcu-divider">
          <span className="wcu-divider-text">How It Works</span>
        </div>

        {/* Steps Section */}
        <div className="wcu-steps">
          <div className="wcu-steps-header">
            <h3 className="wcu-steps-title">Simple 3-Step Process</h3>
            <p className="wcu-steps-subtitle">Get pest-free in just three easy steps</p>
          </div>

          <div className="wcu-steps-grid">
            {steps.map((step, index) => (
              <div className="wcu-step-card" key={step.id}>
                <div className="wcu-step-number">{step.id}</div>
                <div className="wcu-step-icon">{step.icon}</div>
                <h4 className="wcu-step-title">{step.title}</h4>
                <p className="wcu-step-description">{step.description}</p>
                {index < steps.length - 1 && (
                  <div className="wcu-step-arrow">→</div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="wcu-cta">
          <button className="wcu-cta-btn" onClick={handleGetStarted}>
            📞 Call Now: +1 (833) 493-6242 →
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;